import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/scss/main.scss'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
import { EventBus } from '@/assets/js/eventBus.js'
import ImageSlider from './components/ImageSlider'
import Lightbox from './components/Lightbox'
import Timeline from './components/Timeline'
import Tabs from './components/Tabs'
import Sidebar from './views/partials/Sidebar'
import Footer from './views/partials/Footer'
import Images from './assets/json/images.json'

Vue.component('v-icon', Icon)
Vue.component('v-image-slider', ImageSlider)
Vue.component('v-lightbox', Lightbox)
Vue.component('v-timeline', Timeline)
Vue.component('v-tabs', Tabs)
Vue.component('v-sidebar', Sidebar)
Vue.component('v-footer', Footer)

Vue.prototype.$images = Images
console.log(Images)
Vue.prototype.$eventbus = EventBus
let globalData = new Vue({
  data: { $windowWidth: 0 }
})
Vue.mixin({
  computed: {
    $windowWidth: {
      get: function () { return globalData.$data.$windowWidth },
      set: function (width) { globalData.$data.$windowWidth = width }
    }
  }
})

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
